/**
 * Member Status DTO enum - wire format for member status
 * Maps to backend API status values
 */
export enum MemberStatusDTO {
  ACTIVE = 'ACTIVE',
  INVITED = 'INVITED',
  INVITE_EXPIRED = 'INVITE_EXPIRED',
  BASIC = 'BASIC',
  ARCHIVED = 'ARCHIVED',
  PLACEHOLDER = 'PLACEHOLDER',
  /** Display-only: a synced user that may duplicate another one. Only super admins receive it. */
  NEEDS_REVIEW = 'NEEDS_REVIEW',
}

/**
 * Type alias for request - makes intent clear
 */
export type MemberStatusRequest = MemberStatusDTO;

/**
 * Type alias for response - makes intent clear
 */
export type MemberStatusResponse = MemberStatusDTO;
